import { render, staticRenderFns } from "./UserElement.vue?vue&type=template&id=4de4ff96&scoped=true&"
import script from "./UserElement.vue?vue&type=script&lang=js&"
export * from "./UserElement.vue?vue&type=script&lang=js&"
import style0 from "./UserElement.vue?vue&type=style&index=0&id=4de4ff96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4ff96",
  null
  
)

export default component.exports